import http from "../components/config/axiosConfig";

const getBuildVersion = () => {
    return http.get('/version')
};

const build = {
    getBuildVersion
};

export default build